"use strict";

export const calculateFoldDistance = (event) => {
  const form = event.currentTarget.form;
  const {
    footingWidth, footingHeight,
    wallThickness, epsThickness,
    battenWidth, battenThickness,
    fastfootSize, foldDistanceResult
  } = form.elements;

  const exact =
    8.71 +
    (footingWidth.value/2 - wallThickness.value/2 - +epsThickness.value - 2)*0.8 +
    (footingHeight.value - 6)*1.1 +
    +footingWidth.value/2 +
    +battenWidth.value +
    +battenThickness.value/2;

  const total = 2 * exact + 3;

  if (total <= 50) {
    fastfootSize.value = "FF50";
  } else if (total <= 62) {
    fastfootSize.value = "FF62";
  } else if (total <= 74) {
    fastfootSize.value = "FF74";
  } else {
    alert("Footing too large … Contact Fab-Form at (888)303-3278");
  }

  foldDistanceResult.value = Math.round(exact*10)/10;
};
